import CashIcon from 'assets/images/funds/cashbox_4.png'
import { toast } from 'react-toastify'
import { StateConvertor } from 'utilities/helper/cashBoxes'
interface IItemProps {
    item: ICashBoxes
}
export default function Item({ item }: IItemProps) {
    return (
        <div
            className=" bg-white rounded-2xl shadow-[0px 9px 29px 0px rgba(0, 0, 0, 0.2)] py-4 px-3 my-3"
            onClick={() => toast.error('این صفحه درحال پیاده سازی می باشد')}
        >
            <div className=" flex items-center">
                <img src={CashIcon} alt="fund-icon" className=" w-14 h-14" />
                <div className=" mr-3 cursor-pointer">
                    <p className=" font-extrabold">صندوق {item.name}</p>
                    <p className=" text-sm text-gray-4 mt-2">
                        {item.period.valid_memberships_count} عضو ، قرعه کشی
                    </p>
                </div>
            </div>
            <hr className=" my-3" />
            <div>
                <div className=" flex justify-between my-2">
                    <p className=" text-gray-2 text-sm">ارزش هر سهم</p>
                    <p className="">
                        {Number(item.period.share_value).toLocaleString()} تومان
                    </p>
                </div>
                <div className=" flex justify-between my-2">
                    <p className=" text-gray-2 text-sm">سهم های فعلی</p>
                    <p className="">
                        {Number(item.period.total_shares).toLocaleString()} سهم
                    </p>
                </div>
                <div className=" flex justify-between my-2">
                    <p className=" text-gray-2 text-sm">تعداد وام</p>
                    <p className="">
                        {item.period.number_of_loans}
                        وام
                    </p>
                </div>
                <div className=" flex justify-between my-2">
                    <p className=" text-gray-2  text-sm">تاریخ قرعه کشی</p>
                    <p className="">
                        {item.period.day_of_draw.toLocaleString()} ام هر ماه
                    </p>
                </div>
            </div>

            <hr className=" my-3" />
            <p className=" text-gray-2 my-2 text-sm">وضعیت</p>
            <div className=" flex justify-between items-center">
                <p className=" text-gray-2 my-2 text-sm">حالت صندوق</p>
                <p className=" text-xs py-1 px-2  text-gray-6 bg-gray-5 rounded-md items-center">
                    {StateConvertor[item.state]}
                </p>
            </div>
        </div>
    )
}
